import script from "./NoticeList.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeList.vue?vue&type=script&setup=true&lang=js"

import "./NoticeList.vue?vue&type=style&index=0&id=88b0573e&lang=css"

const __exports__ = script;

export default __exports__